import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import './ProductColorPicker.less';
import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';

function ProductColorPicker({ colors, activeColor, maxColorsToShow, link, onSelect, swatchWidth }) {
  const visibleColors =
    maxColorsToShow && colors.length > maxColorsToShow ? colors.slice(0, maxColorsToShow) : colors;

  let frontCircleR;
  let backCircleR;
  let activeCircleR;
  let transformFront;
  let transformBack;

  if (swatchWidth && !isMobile()) {
    const backWidth = swatchWidth + 1;
    frontCircleR = `${swatchWidth}px`;
    backCircleR = `${backWidth}px`;
    activeCircleR = `${swatchWidth + 8}px`;
    transformFront = `translate(-${swatchWidth / 2}px, -${swatchWidth / 2}px)`;
    transformBack = `translate(-${backWidth / 2}px, -${backWidth / 2}px)`;
  }
  return (
    <div className="product-color-picker">
      {visibleColors.map(color => {
        let wrapperStyle;
        let circleBackStyle;
        let circleFrontStyle = { background: `#${color.value}` };
        if (swatchWidth && !isMobile()) {
          wrapperStyle = {
            width: activeCircleR,
            height: activeCircleR,
            border: activeColor === color.value ? '1px solid #21201F' : '1px solid transparent',
          };
          circleBackStyle = {
            width: backCircleR,
            height: backCircleR,
            transform: transformBack,
            border: '1px solid #C0C0C0',
          };
          circleFrontStyle = {
            background: `#${color.value}`,
            width: frontCircleR,
            height: frontCircleR,
            transform: transformFront,
          };
        }
        return (
          <span
            key={color.value}
            className={`circle-wrapper${activeColor === color.value ? ' active' : ''}`}
            onClick={() => onSelect(color)}
            style={wrapperStyle}
          >
            <span className="circle back" style={circleBackStyle} />
            <span className="circle front" data-label={color.label} style={circleFrontStyle} />
          </span>
        );
      })}
      {link && maxColorsToShow && colors.length > maxColorsToShow && (
        <Link className="zola-ui link more" to={link}>
          more
        </Link>
      )}
    </div>
  );
}

ProductColorPicker.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.shape({})),
  activeColor: PropTypes.string,
  // small: PropTypes.bool,
  maxColorsToShow: PropTypes.number,
  link: PropTypes.string,
  onSelect: PropTypes.func,
  swatchWidth: PropTypes.number,
};

export default ProductColorPicker;



// WEBPACK FOOTER //
// ./src/cards/components/common/ProductColorPicker/ProductColorPicker.jsx